import { Icon } from "rsuite";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import {
  StyleTypeContext,
  TranslationContext,
} from "../../..//umbilical_tools";
import tourHightlightBulletIcon from "../../icons/tourHightlightBulletIcon.svg";
import { cStyler } from "../../../helpers";
import jssVariables from "../../../jss_setup";

const highlightsStyles = createUseStyles({
  highlights: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    gridAutoRows: "max-content",
    ..._.get(props, "customStyles.highlights", {}),
  }),
  title: (props) => ({
    fontSize: "xx-large",
    ..._.get(props, "customStyles.highlightsTitle", {}),
  }),
  highlights_list: (props) => ({
    borderRadius: "5px",
    border: `4px solid ${jssVariables.colors.base_color}`,
    padding: jssVariables.normal_gap,
    display: "grid",
    gridGap: jssVariables.normal_gap,
    maxHeight: "40vh",
    overflow: "auto",
    ..._.get(props, "customStyles.highlights_list", {}),
  }),
  description: (props) => ({
    display: "grid",
    gridTemplateColumns: "min-content 1fr",
    gridGap: jssVariables.normal_gap,
    alignItems: "center",
    fontWeight: "normal",
    ..._.get(props, "customStyles.highlightsDescription", {}),
  }),
  icon: (props) => ({
    color: jssVariables.colors.base_color,
    ..._.get(props, "customStyles.icon", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {
    highlights_list: (props) => ({
      maxHeight: "50vh",
      ..._.get(props, "customStyles.highlights_list.smallscreen", {}),
    }),
  },
});
const Highlights = ({ highlights }) => {
  const { type, brand } = useContext(StyleTypeContext);
  const { t } = useContext(TranslationContext);

  const customStyles = cStyler({
    type,
    brand,
    objName: "tourAddOnItineraryStyles",
  });

  const classes = highlightsStyles({
    customStyles,
  });

  if (!highlights.length) {
    return null;
  }

  return (
    <div className={classes.highlights}>
      <h4 className={classes.title}>{t("highlights")}</h4>
      <div className={classes.highlights_list}>
        {highlights.map((hl, idx) => {
          return (
            <h6 key={idx} className={classes.description}>
              {type === "type2" ? (
                <img
                  className={classes.logo}
                  alt=""
                  src={tourHightlightBulletIcon}
                />
              ) : (
                <Icon className={classes.icon} icon="dot-circle-o" size="2x" />
              )}
              {hl.description_en}
            </h6>
          );
        })}
      </div>
    </div>
  );
};
Highlights.defaultProps = {
  highlights: [],
};
Highlights.propTypes = {
  highlights: PropTypes.array.isRequired,
};
export default Highlights;
